import type { BQRoutineArgumentConfig } from './types';

export const getValueFromArgumentConfig = (config: BQRoutineArgumentConfig) => {
  switch (config.dataType) {
    case 'STRING':
      return config.defaultStringValue;
    case 'INT64':
      return config.defaultIntValue;
    case 'BOOL':
      return config.defaultBooleanValue;
    case 'ARRAY<INT64>':
      return config.defaultArrayValue;
    case 'ARRAY<STRING>':
      return config.defaultArrayValue;
    case 'DATE':
      return config.defaultDateValue;
    default:
      return null;
  }
};

export const getFieldNameFromDataType = (dataType: string) => {
  switch (dataType) {
    case 'STRING':
      return 'defaultStringValue';
    case 'INT64':
      return 'defaultIntValue';
    case 'FLOAT64':
      return 'defaultFloatValue';
    case 'BOOL':
      return 'defaultBooleanValue';
    case 'ARRAY<FLOAT64>':
    case 'ARRAY<BOOL>':
    case 'ARRAY<INT64>':
    case 'ARRAY<STRING>':
      return 'defaultArrayValue';
    case 'DATE':
      return 'defaultDateValue';
    default:
      return null;
  }
};

export const getArgumentsConfigAsObject = (
  config: BQRoutineArgumentConfig[],
) => {
  const result: Object = {};
  config.forEach(argument => {
    result[argument.argumentName] = getValueFromArgumentConfig(argument);
  });
  return result;
};
